function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license
 * Copyright (c) 2015 - 2023 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */
import { ComboBoxPlaceholder } from './vaadin-combo-box-placeholder.js';
/**
 * @polymerMixin
 */

export var ComboBoxDataProviderMixin = function ComboBoxDataProviderMixin(superClass) {
  return /*#__PURE__*/function (_superClass) {
    _inherits(DataProviderMixin, _superClass);

    var _super = _createSuper(DataProviderMixin);

    function DataProviderMixin() {
      _classCallCheck(this, DataProviderMixin);

      return _super.apply(this, arguments);
    }

    _createClass(DataProviderMixin, [{
      key: "ready",
      value:
      /** @protected */
      function ready() {
        var _this = this;

        _get(_getPrototypeOf(DataProviderMixin.prototype), "ready", this).call(this);

        this._scroller.addEventListener('index-requested', function (e) {
          var index = e.detail.index;
          var currentScrollerPos = e.detail.currentScrollerPos;
          var allowedIndexRange = Math.floor(_this.pageSize * 1.5); // Ignores the indexes, which are being re-sent during scrolling reset,
          // if the corresponding page is around the current scroller position.
          // Otherwise, there might be a last pages duplicates, which cause the
          // loading indicator hanging and blank items

          if (_this._shouldSkipIndex(index, allowedIndexRange, currentScrollerPos)) {
            return;
          }

          if (index !== undefined) {
            var page = _this._getPageForIndex(index);

            if (_this._shouldLoadPage(page)) {
              _this._loadPage(page);
            }
          }
        });
      }
      /** @private */

    }, {
      key: "_dataProviderFilterChanged",
      value: function _dataProviderFilterChanged(filter) {
        if (this.__previousDataProviderFilter === undefined && filter === '') {
          this.__previousDataProviderFilter = filter;
          return;
        }

        if (this.__previousDataProviderFilter !== filter) {
          this.__previousDataProviderFilter = filter;
          this._pendingRequests = {}; // Immediately mark as loading if this refresh leads to re-fetching pages
          // This prevents some issues with the properties below triggering
          // observers that also rely on the loading state

          this.loading = this._shouldFetchData(); // Reset size and internal loading state

          this.size = undefined;
          this.clearCache();
        }
      }
      /** @private */

    }, {
      key: "_shouldFetchData",
      value: function _shouldFetchData() {
        if (!this.dataProvider) {
          return false;
        }

        return this.opened || this.filter && this.filter.length;
      }
      /** @private */

    }, {
      key: "_ensureFirstPage",
      value: function _ensureFirstPage(opened) {
        if (opened && this._shouldLoadPage(0)) {
          this._loadPage(0);
        }
      }
      /** @private */

    }, {
      key: "_shouldSkipIndex",
      value: function _shouldSkipIndex(index, allowedIndexRange, currentScrollerPos) {
        return currentScrollerPos !== 0 && index >= currentScrollerPos - allowedIndexRange && index <= currentScrollerPos + allowedIndexRange;
      }
      /** @private */

    }, {
      key: "_shouldLoadPage",
      value: function _shouldLoadPage(page) {
        if (!this.filteredItems || this._forceNextRequest) {
          this._forceNextRequest = false;
          return true;
        }

        var loadedItem = this.filteredItems[page * this.pageSize];

        if (loadedItem !== undefined) {
          return loadedItem instanceof ComboBoxPlaceholder;
        }

        return this.size === undefined;
      }
      /** @private */

    }, {
      key: "_loadPage",
      value: function _loadPage(page) {
        var _this2 = this;

        // Make sure same page isn't requested multiple times.
        if (this._pendingRequests[page] || !this.dataProvider) {
          return;
        }

        var params = {
          page: page,
          pageSize: this.pageSize,
          filter: this.filter
        };

        var callback = function callback(items, size) {
          if (_this2._pendingRequests[page] !== callback) {
            return;
          }

          var filteredItems = _this2.filteredItems ? _toConsumableArray(_this2.filteredItems) : [];
          filteredItems.splice.apply(filteredItems, [params.page * params.pageSize, items.length].concat(_toConsumableArray(items)));
          _this2.filteredItems = filteredItems;

          if (!_this2.opened && !_this2._isInputFocused()) {
            _this2._commitValue();
          }

          if (size !== undefined) {
            _this2.size = size;
          }

          delete _this2._pendingRequests[page];

          if (Object.keys(_this2._pendingRequests).length === 0) {
            _this2.loading = false;
          }
        };

        this._pendingRequests[page] = callback; // Set the `loading` flag only after marking the request as pending
        // to prevent the same page from getting requested multiple times
        // as a result of `__loadingChanged` in the scroller which requests
        // a virtualizer update which in turn may trigger a data provider page request.

        this.loading = true;
        this.dataProvider(params, callback);
      }
      /** @private */

    }, {
      key: "_getPageForIndex",
      value: function _getPageForIndex(index) {
        return Math.floor(index / this.pageSize);
      }
      /**
       * Clears the cached pages and reloads data from dataprovider when needed.
       */

    }, {
      key: "clearCache",
      value: function clearCache() {
        if (!this.dataProvider) {
          return;
        }

        this._pendingRequests = {};
        var filteredItems = [];

        for (var i = 0; i < (this.size || 0); i++) {
          filteredItems.push(this.__placeHolder);
        }

        this.filteredItems = filteredItems;

        if (this._shouldFetchData()) {
          this._forceNextRequest = false;

          this._loadPage(0);
        } else {
          this._forceNextRequest = true;
        }
      }
      /** @private */

    }, {
      key: "_sizeChanged",
      value: function _sizeChanged() {
        var size = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var filteredItems = (this.filteredItems || []).slice(0, size);

        for (var i = 0; i < size; i++) {
          filteredItems[i] = filteredItems[i] !== undefined ? filteredItems[i] : this.__placeHolder;
        }

        this.filteredItems = filteredItems; // Cleans up the redundant pending requests for pages > size
        // Refers to https://github.com/vaadin/vaadin-flow-components/issues/229

        this._flushPendingRequests(size);
      }
      /** @private */

    }, {
      key: "_pageSizeChanged",
      value: function _pageSizeChanged(pageSize, oldPageSize) {
        if (Math.floor(pageSize) !== pageSize || pageSize < 1) {
          this.pageSize = oldPageSize;
          throw new Error('`pageSize` value must be an integer > 0');
        }

        this.clearCache();
      }
      /** @private */

    }, {
      key: "_dataProviderChanged",
      value: function _dataProviderChanged(dataProvider, oldDataProvider) {
        var _this3 = this;

        this._ensureItemsOrDataProvider(function () {
          _this3.dataProvider = oldDataProvider;
        });

        this.clearCache();
      }
      /** @private */

    }, {
      key: "_ensureItemsOrDataProvider",
      value: function _ensureItemsOrDataProvider(restoreOldValueCallback) {
        if (this.items !== undefined && this.dataProvider !== undefined) {
          restoreOldValueCallback();
          throw new Error('Using `items` and `dataProvider` together is not supported');
        } else if (this.dataProvider && !this.filteredItems) {
          this.filteredItems = [];
        }
      }
      /** @private */

    }, {
      key: "_warnDataProviderValue",
      value: function _warnDataProviderValue(dataProvider, value) {
        if (dataProvider && value !== '' && (this.selectedItem === undefined || this.selectedItem === null)) {
          var valueIndex = this.__getItemIndexByValue(this.filteredItems, value);

          if (valueIndex < 0 || !this._getItemLabel(this.filteredItems[valueIndex])) {
            console.warn('Warning: unable to determine the label for the provided `value`. ' + 'Nothing to display in the text field. This usually happens when ' + 'setting an initial `value` before any items are returned from ' + 'the `dataProvider` callback. Consider setting `selectedItem` ' + 'instead of `value`');
          }
        }
      }
      /**
       * This method cleans up the page callbacks which refers to the
       * non-existing pages, i.e. which item indexes are greater than the
       * changed size.
       * This case is basically happens when:
       * 1. Users scroll fast to the bottom and combo box generates the
       * redundant page request/callback
       * 2. Server side uses undefined size lazy loading and suddenly reaches
       * the exact size which is on the range edge
       * (for default page size = 50, it will be 100, 200, 300, ...).
       * @param size the new size of items
       * @private
       */

    }, {
      key: "_flushPendingRequests",
      value: function _flushPendingRequests(size) {
        if (this._pendingRequests) {
          var lastPage = Math.ceil(size / this.pageSize);
          Object.entries(this._pendingRequests).forEach(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                page = _ref2[0],
                callback = _ref2[1];

            if (parseInt(page) >= lastPage) {
              callback([], size);
            }
          });
        }
      }
    }], [{
      key: "properties",
      get: function get() {
        return {
          /**
           * Number of items fetched at a time from the dataprovider.
           * @attr {number} page-size
           * @type {number}
           */
          pageSize: {
            type: Number,
            value: 50,
            observer: '_pageSizeChanged'
          },

          /**
           * Total number of items.
           * @type {number | undefined}
           */
          size: {
            type: Number,
            observer: '_sizeChanged'
          },

          /**
           * Function that provides items lazily. Receives arguments `params`, `callback`
           *
           * `params.page` Requested page index
           *
           * `params.pageSize` Current page size
           *
           * `params.filter` Currently applied filter
           *
           * `callback(items, size)` Callback function with arguments:
           *   - `items` Current page of items
           *   - `size` Total number of items.
           * @type {ComboBoxDataProvider | undefined}
           */
          dataProvider: {
            type: Object,
            observer: '_dataProviderChanged'
          },

          /** @private */
          _pendingRequests: {
            value: function value() {
              return {};
            }
          },

          /** @private */
          __placeHolder: {
            value: new ComboBoxPlaceholder()
          },

          /** @private */
          __previousDataProviderFilter: {
            type: String
          }
        };
      }
    }, {
      key: "observers",
      get: function get() {
        return ['_dataProviderFilterChanged(filter)', '_warnDataProviderValue(dataProvider, value)', '_ensureFirstPage(opened)'];
      }
    }]);

    return DataProviderMixin;
  }(superClass);
};